module.exports = __webpack_public_path__ + "static/img/invest-consume10.efdc820.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-consume10.jpg
// module id = zVYk
// module chunks = 0